import { useContext } from 'react';

import BonusPeriodsContext from 'contexts/BonusPeriodsContext';

/**
 * True when the selected bonus period uses sub-periods (weekly windows). In this
 * case the bonus reward slideout sections show only the per-week fact table (the
 * single-week card is dropped); a total header is added on sign-off boards.
 */
const useHasBonusSubPeriods = (): boolean => {
  const { selectedBonusPeriod } = useContext(BonusPeriodsContext);
  return (
    !!selectedBonusPeriod &&
    'subPeriods' in selectedBonusPeriod &&
    !!selectedBonusPeriod.subPeriods?.length
  );
};

export default useHasBonusSubPeriods;
